import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import ChatWidget from "@/components/ChatWidget";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import TestsPage from "@/pages/TestsPage";
import PackagesPage from "@/pages/PackagesPage";
import HomeCollectionPage from "@/pages/HomeCollectionPage";
import BookTestPage from "@/pages/BookTestPage";
import ContactPage from "@/pages/ContactPage";
import FaqPage from "@/pages/FaqPage";
import { PrivacyPolicyPage, TermsPage, DisclaimerPage } from "@/pages/LegalPages";
import AdminPage from "@/pages/AdminPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="pb-[72px] md:pb-0">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/tests" element={<TestsPage />} />
            <Route path="/health-packages" element={<PackagesPage />} />
            <Route path="/home-sample-collection" element={<HomeCollectionPage />} />
            <Route path="/book-a-test" element={<BookTestPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsPage />} />
            <Route path="/medical-disclaimer" element={<DisclaimerPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
        <ChatWidget />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
